const formatMessageReplaceFirstBracketPair = message => {
  const start = message.indexOf("[");
  const end = message.indexOf("]", start);

  if (start === -1 || end === -1) return message;

  return (
    message.slice(0, start) +
    message.slice(start + 1, end) +
    ":" +
    message.slice(end + 1)
  );
};

export default formatMessageReplaceFirstBracketPair;
